import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
})
export class SortByPipe implements PipeTransform {
  transform(items: any[], reverse: boolean, sortedBy: string): any {
    let shortedData;

    if (items == undefined) return shortedData;

    if (!reverse) {
      shortedData = items.sort((a, b) => {
        const nameA = a[sortedBy];
        const nameB = b[sortedBy];
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      });
    } else {
      shortedData = items.sort((a, b) => {
        const nameA = a[sortedBy];
        const nameB = b[sortedBy];
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
      });
    }
    return shortedData;
  }
}
